/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Public API for render
export { RenderComponentType, Renderer, RootRenderer } from './render/api';
//# sourceMappingURL=render.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-google-login/~/@angular/core/src/render.js
// module id = 1386
// module chunks = 21